/**
 * Constrains drag movement to vertical axis only.
 *
 * @hello-pangea/dnd applies CSS transforms (translate/translate3d) to position
 * the dragged element. This function modifies the transform to lock the X-axis
 * to 0, allowing only vertical movement.
 *
 * @param style - The draggable props style object from @hello-pangea/dnd
 * @returns Modified style with X translation locked to 0px
 */
export const getVerticalOnlyStyle = (
  style: React.CSSProperties | undefined,
): React.CSSProperties | undefined => {
  if (!style?.transform) {
    return style;
  }

  const { transform, ...rest } = style;
  const lockedTransform = transform
    .replace(/translate3d\([^,]+,/, "translate3d(0px,")
    .replace(/translate\([^,]+,/, "translate(0px,");

  return { ...rest, transform: lockedTransform };
};
